/**
 * @name 注册插件、样式等
 */
import Vue from 'vue';
import '@/axios/index.js';
//import 'babel-polyfill';
import 'vant/lib/index.css';
// import './vant';
import filters from '@/filters/index.js';
import directives from '@/directive/index.js';
import '../style/reset.scss';
import '../style/scroll.scss';
import platform from '@/utils/platform';



// 开启调试工具判断
if (window.location.href.includes('debugger') || window.location.href.includes('debugger_vconsole') ) {
  const VConsole = require('vconsole')
  new VConsole();
}


/** filters集循环绑定到Vue.filter */
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

// 全局注册自定义指令
Object.keys(directives).forEach(k => Vue.directive(k, directives[k]))

// 友盟埋点
function umengInitHandler() {
  (function (w, d, s, q, i) {
    w[q] = w[q] || [];
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s);
    j.async = true;
    j.id = 'beacon-aplus';
    j.src = 'https://d.alicdn.com/alilog/mlog/aplus/' + i + '.js';
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'aplus_queue', '203467608');

  const { aplus_queue } = window;
  //集成应用的appKey
  aplus_queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['appKey', '654991db58a9eb5b0a028ed1'],
  });
  //sdk提供手动pv发送机制，启用手动pv(即关闭自动pv)，需设置aplus-waiting=MAN;
  //注意：由于单页面路由改变时不会刷新页面，无法自动发送pv，所以对于单页应用，强烈建议您关闭自动PV, 手动控制PV事件
  aplus_queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['aplus-waiting', 'MAN'],
  });
  //是否开启调试模式
  aplus_queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['DEBUG', true],
  });
}
umengInitHandler();

// 上报友盟埋点-事件统计
Vue.prototype.$umengTrack = function (trackId, param = {}) {
  const { aplus_queue } = window;
  aplus_queue.push({
    action: 'aplus.record',
    arguments: [
      trackId,
      'CLK',
      {
        ...param,
        origin: window.location.origin,
        page: window.location.href
      },
    ],
  });
}
Vue.prototype.makePhoneNew = function (phone) {
  if (!phone) {
    return;
  } else {
    if (platform.isOneWO) {
      window.yc.baseRequest('callNumber', {
        content: Number(phone),
      });
    } else {
      const url = window.location?.href;
      let href = url.split('?')[0];
      href += '?';
      const options = this.$route.query;
      for (const i in options) {
        if (!['code', 'token'].indexOf(i)) {
          href += `${i}=${options[i]}&`;
        }
      }
      href += 'callPhone=' + phone;
      window.wx.miniProgram.navigateTo({
        url: '/subPages/action/pages/makePhoneCall?h5Url=' + encodeURIComponent(href),
      });
    }
  }
}